// Port of api/fuel/app/classes/filter/search/games/rules/query/version_name.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'version_name',
	contains: function(rule, config, filter, data, query) {
		var keywords = Rule.getKeywords(Rule.value(rule))
		var opMap = Rule.operandMapped(rule, { '=': 'like', '!=': 'not like' })
		for (var i = 0; i < keywords.length; i++) {
			query.whereGroup('OR', [
				['v.game_version_name', opMap, '%' + keywords[i] + '%'],
				['v.game_version_localised', opMap, '%' + keywords[i] + '%']
			])
		}
	}
})
